import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FolderListDeletedEvent } from 'src/app/models/events/folder-list-deleted-event';
import { FolderListRefreshEvent } from 'src/app/models/events/folder-list-refresh-event';
import { FolderListUpdatedEvent } from 'src/app/models/events/folder-list-updated-event';

@Injectable({
    providedIn: 'root',
})
export class FollowedFoldersEventsService {
    /**
     * Emis lorsque la liste des dossiers doit être completement rechargées
     */
    public listNeedRefresh = new Subject<FolderListRefreshEvent>();

    /**
     * Emis lorsque des dossiers de la liste doivent être mis à jour
     */
    public foldersUpdated = new Subject<FolderListUpdatedEvent>();

    /**
     * Emis lorsque des dossiers de la liste doivent être supprimés
     */
    public foldersDeleted = new Subject<FolderListDeletedEvent>();
}
